// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent_card {
  background-color: #f2f2f2;
  font-size: 12px;
}

.agent_feild {
  float: left;
  width: 100%;
}

.agent_type_feild {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -6px;
}

.agent_type {
  width: 100%;
  height: 30px;
  position: relative;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.agent_name_text {
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

::ng-deep.agentmodaledit .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.agentmodaledit {
  top: 0% !important;
  width: 88vw !important;
  left: 12% !important;
  margin-top: 7% !important;
  height: 83vh !important;
}

::ng-deep.agentmodaladd .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.agentmodaladd {
  top: 0% !important;
  width: 95vw !important;
  left: 4.5% !important;
  margin-top: 7% !important;
  height: 83vh !important;
}

.agent_form_field {
  width: 100%;
}

.agent_form_field input {
  font-size: 12px !important;
}

.active_mode {
  color: #07a36e;
}

.testing_mode {
  color: #f2f2f2;
}

::ng-deep.mat-form-field .mat-form-field-wrapper {
  padding-bottom: 1%;
}

.configtable td {
  padding: 1% !important;
}

.configtable tr:hover {
  background-color: #f3eded;
  cursor: pointer;
}

.agent_title {
  color: #0c0c0c;
  text-align: initial;
  font-size: 12px !important;
  font-weight: 700;
}

.text-ellipsis {
  max-width: 83%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.active_table {
  background-color: rgba(23, 162, 184, 0.231372549);
}

.agent_text {
  color: black;
  top: 7px;
}

.copy_icon {
  background-repeat: no-repeat;
  display: inline-block;
  fill: currentColor;
  height: 24px;
  width: 24px;
  font-size: 18px;
  position: relative;
  top: 8%;
  left: 2%;
  cursor: pointer;
}

::ng-deep.agent_form_field .mat-form-field-empty.mat-form-field-label {
  display: block;
  position: relative !important;
  top: 7px !important;
}

::ng-deep.agent_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {
  transform: translateY(-1.59375em) scale(0.75);
  width: 133.33333%;
  position: relative;
  top: 13px !important;
}

.agent_form_field {
  width: 100%;
}

.agent_form_field input {
  font-size: 12px !important;
}

::ng-deep.agent_form_field .mat-form-field-infix {
  padding: 0% !important;
  padding-bottom: 7px !important;
  padding-top: 2px !important;
}

.addconfigbtn {
  background-color: #17a0b4 !important;
  font-size: 12px !important;
  color: white;
  height: 28px !important;
  line-height: 20px;
  right: 1%;
  top: 0%;
  cursor: pointer;
}

.selectpipeline {
  width: 87%;
}

.notselectedpipeline {
  width: 76%;
}

.autocomplete-container {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25) !important;
  position: relative !important;
  overflow: visible !important;
  height: 34px !important;
  border-radius: 5px !important;
}

.agentedit {
  position: relative;
  overflow-x: hidden;
  height: 69vh;
}

::ng-deep.agmatoutlinestyles.mat-mdc-form-field {
  width: 100%;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mdc-text-field--outlined {
  padding: 6px !important;
  height: 31px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex {
  height: 30px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mdc-notched-outline .mdc-floating-label {
  font-size: 11px !important;
  padding-bottom: 24px;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-input-element {
  position: relative;
  font-size: 12px !important;
  bottom: 8px !important;
}
::ng-deep.agmatoutlinestyles.mat-mdc-form-field .mat-mdc-text-field-wrapper .mat-mdc-form-field-flex .mat-mdc-form-field-infix {
  bottom: 11px !important;
}

::ng-deep.agmatoutlinestyles.dateicon .mat-mdc-form-field-icon-suffix {
  bottom: 5px !important;
}

::ng-deep.agmatoutlinestyles .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}

::ng-deep.modalConfigJSONagent .modal-dialog {
  margin: 0 !important;
  padding: 0 !important;
  top: 0% !important;
}
::ng-deep.modalConfigJSONagent .modal-dialog .modal-content {
  width: 88vw !important;
}

::ng-deep.modalConfigJSONagentbig .modal-dialog {
  margin: 0 !important;
  padding: 0 !important;
  top: 0% !important;
  left: 1% !important;
}
::ng-deep.modalConfigJSONagentbig .modal-dialog .modal-content {
  width: 85vw !important;
}

::ng-deep.modalConfigJSONagentsmall .modal-dialog {
  margin: 0 !important;
  padding: 0 !important;
  top: 0% !important;
  left: 30% !important;
}
::ng-deep.modalConfigJSONagentsmall .modal-dialog .modal-content {
  width: 30vw !important;
}
::ng-deep.modalConfigJSONagentsmall .modal-dialog .modal-content .messageioteditor .editor-container .monaco-editor {
  width: 1139px !important;
  height: 358px !important;
}
::ng-deep.modalConfigJSONagentsmall .modal-dialog .modal-content .messageioteditor .editor-container .monaco-editor .overflow-guard {
  width: 1139px !important;
  height: 358px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/agents/agent/agent.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AACA;EACI,yBAAA;EAA0B,eAAA;AAC9B;;AACI;EACI,WAAA;EACA,WAAA;AAER;;AACM;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAER;;AAAM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAGR;;AAAM;EACE,sBAAA;AAGR;;AAAM;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AAGR;;AAAM;EACE,8BAAA;AAGR;;AADM;EACE,8BAAA;AAIR;;AAFM;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AAKR;;AAFM;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAKR;;AAHM;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,yBAAA;EACA,uBAAA;AAMR;;AAJM;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAOR;;AALM;EACE,kBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,uBAAA;AAQR;;AANM;EACE,WAAA;AASR;;AANM;EACE,0BAAA;AASR;;AAPM;EACE,cAAA;AAUR;;AARM;EACE,cAAA;AAWR;;AATM;EACE,kBAAA;AAYR;;AAVM;EACE,sBAAA;AAaR;;AAXM;EACE,yBAAA;EACA,eAAA;AAcR;;AAXI;EACE,cAAA;EAAe,mBAAA;EAAmB,0BCnG7B;EDmGiD,gBAAA;AAiB5D;;AAdI;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAiBN;;AAdE;EACE,iDAAA;AAiBJ;;AAfE;EACE,YAAA;EACE,QAAA;AAkBN;;AAhBE;EACE,4BAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AAmBJ;;AAjBE;EACE,cAAA;EACA,6BAAA;EACA,mBAAA;AAoBJ;;AAjBE;EACE,6CAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAoBJ;;AAlBE;EACE,WAAA;AAqBJ;;AAlBE;EACE,0BAAA;AAqBJ;;AAnBE;EACE,sBAAA;EACA,8BAAA;EACA,2BAAA;AAsBJ;;AApBE;EACE,oCC1JQ;ED2JR,0BC1JO;ED2JP,YAAA;EACA,uBC1JQ;ED2JR,iBAAA;EACA,SAAA;EACA,OAAA;EACA,eAAA;AAuBJ;;AArBE;EACE,UAAA;AAwBJ;;AAtBE;EACE,UAAA;AAyBJ;;AAvBE;EACE,oDAAA;EACA,6BAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;AA0BJ;;AAxBA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;AA2BF;;AAxBA;EACE,WAAA;AA2BF;AA1BE;EACE,uBAAA;EACA,uBAAA;AA4BJ;AAzBI;EACE,uBAAA;AA2BN;AA1BM;EACI,0BAAA;EACA,oBAAA;AA4BV;AA1BM;EACE,kBAAA;EACA,0BAAA;EACA,sBAAA;AA4BR;AA1BM;EACE,uBAAA;AA4BR;;AAvBA;EACA,sBAAA;AA0BA;;AAvBE;EACE,wBAAA;AA0BJ;;AAvBA;EACE,oBAAA;EACA,qBAAA;EACA,kBAAA;AA0BF;AAzBE;EACE,sBAAA;AA2BJ;;AAxBA;EACE,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AA2BF;AA1BE;EACE,sBAAA;AA4BJ;;AAzBA;EACE,oBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;AA4BF;AA3BE;EACE,sBAAA;AA6BJ;AA1BQ;EACE,wBAAA;EACA,wBAAA;AA4BV;AA3BU;EACE,wBAAA;EACA,wBAAA;AA6BZ","sourcesContent":["@import \"../../../variables.scss\";\r\n.parent_card{\r\n    background-color:#f2f2f2; font-size: 12px;\r\n    }\r\n    .agent_feild {\r\n        float: left;\r\n        width: 100%;\r\n      }\r\n\r\n      .agent_type_feild {\r\n        width: 100%;\r\n        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n        border-radius: 5px;\r\n        padding-inline: 1%;\r\n        top: -6px;\r\n      }\r\n      .agent_type {\r\n        width: 100%;\r\n        height: 30px;\r\n        position: relative;\r\n      }\r\n\r\n      ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline{\r\n        height: 0px !important;\r\n      }\r\n\r\n      ::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n        top: 0;\r\n        height: 0px !important;\r\n        overflow: hidden;\r\n      }\r\n\r\n      .active_card {\r\n        border-left: 4px solid #07a36e;\r\n      }\r\n      .failed_card {\r\n        border-left: 4px solid #da606c;\r\n      }\r\n      .agent_name_text{\r\n        font-size: 12px;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        max-width: 90% !important;\r\n        display: inline-block;\r\n      }\r\n\r\n      ::ng-deep.agentmodaledit .modal-dialog {\r\n        max-width: 97%!important;\r\n        max-height: 60%!important;\r\n        height: 60%!important;\r\n        margin: auto!important;\r\n        padding: 0 !important;\r\n      }\r\n      ::ng-deep.agentmodaledit{\r\n        top: 0%!important;\r\n        width: 88vw !important;\r\n        left: 12% !important;\r\n        margin-top: 7% !important;\r\n        height: 83vh !important;\r\n      }\r\n      ::ng-deep.agentmodaladd .modal-dialog {\r\n        max-width: 97%!important;\r\n        max-height: 60%!important;\r\n        height: 60%!important;\r\n        margin: auto!important;\r\n        padding: 0 !important;\r\n      }\r\n      ::ng-deep.agentmodaladd{\r\n        top: 0%!important;\r\n        width: 95vw !important;\r\n        left: 4.5% !important;\r\n        margin-top: 7% !important;\r\n        height: 83vh !important;\r\n      }\r\n      .agent_form_field{\r\n        width: 100%;\r\n\r\n      }\r\n      .agent_form_field input{\r\n        font-size: 12px!important;\r\n      }\r\n      .active_mode{\r\n        color: #07a36e;\r\n      }\r\n      .testing_mode{\r\n        color:#f2f2f2;\r\n      }\r\n      ::ng-deep.mat-form-field .mat-form-field-wrapper{\r\n        padding-bottom: 1%;\r\n      }\r\n      .configtable td{\r\n        padding: 1%!important;\r\n      }\r\n      .configtable tr:hover {\r\n        background-color: #f3eded;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .agent_title{\r\n      color: #0c0c0c;text-align:initial;font-size:$fontsize;font-weight: 700;\r\n    }\r\n\r\n    .text-ellipsis{\r\n      max-width: 83%;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      white-space: nowrap;\r\n  }\r\n\r\n  .active_table{\r\n    background-color: #17a2b83b;\r\n  }\r\n  .agent_text{\r\n    color: black;\r\n      top: 7px;\r\n  }\r\n  .copy_icon{\r\n    background-repeat: no-repeat;\r\n    display: inline-block;\r\n    fill: currentColor;\r\n    height: 24px;\r\n    width: 24px;\r\n    font-size: 18px;\r\n    position: relative;\r\n    top: 8%;\r\n    left: 2%;\r\n    cursor: pointer;\r\n  }\r\n  ::ng-deep.agent_form_field .mat-form-field-empty.mat-form-field-label {\r\n    display: block;\r\n    position: relative !important;\r\n    top: 7px !important;\r\n  }\r\n\r\n  ::ng-deep.agent_form_field.mat-form-field-appearance-outline.mat-form-field-can-float.mat-form-field-should-float .mat-form-field-label {\r\n    transform: translateY(-1.59375em) scale(.75);\r\n    width: 133.33333%;\r\n    position: relative;\r\n    top: 13px !important;\r\n  }\r\n  .agent_form_field{\r\n    width: 100%;\r\n\r\n  }\r\n  .agent_form_field input{\r\n    font-size: 12px!important;\r\n  }\r\n  ::ng-deep.agent_form_field .mat-form-field-infix{\r\n    padding: 0%!important;\r\n    padding-bottom: 7px!important;\r\n    padding-top: 2px!important;\r\n  }\r\n  .addconfigbtn{\r\n    background-color:$btn-color;\r\n    font-size: $fontsize;\r\n    color:white ;\r\n    height: $btnHeight;\r\n    line-height: 20px;\r\n    right: 1%;\r\n    top: 0%;\r\n    cursor: pointer;\r\n  }\r\n  .selectpipeline{\r\n    width:87%;\r\n  }\r\n  .notselectedpipeline{\r\n    width:76%;\r\n  }\r\n  .autocomplete-container {\r\n    box-shadow: 0 2px 5px rgb(0 0 0 / 25%) !important;\r\n    position: relative !important;\r\n    overflow: visible !important;\r\n    height: 34px !important;\r\n    border-radius: 5px !important;\r\n}\r\n.agentedit{\r\n  position: relative;\r\n  overflow-x: hidden;\r\n  height: 69vh;\r\n}\r\n\r\n::ng-deep.agmatoutlinestyles.mat-mdc-form-field{ \r\n  width: 100%;\r\n  .mdc-text-field--outlined {\r\n    padding: 6px !important;\r\n    height: 31px !important;\r\n  }\r\n  .mat-mdc-text-field-wrapper{\r\n    .mat-mdc-form-field-flex {\r\n      height: 30px !important;\r\n      .mdc-notched-outline .mdc-floating-label{\r\n          font-size: 11px !important;\r\n          padding-bottom: 24px;\r\n      }\r\n      .mat-mdc-input-element{\r\n        position: relative;\r\n        font-size: 12px !important;\r\n        bottom: 8px !important;\r\n      }\r\n      .mat-mdc-form-field-infix{\r\n        bottom: 11px !important;\r\n      }\r\n    }\r\n }\r\n}\r\n::ng-deep.agmatoutlinestyles.dateicon .mat-mdc-form-field-icon-suffix{\r\nbottom: 5px !important;\r\n}\r\n::ng-deep.agmatoutlinestyles{\r\n  .mat-mdc-form-field-subscript-wrapper{\r\n    display: none !important;\r\n  }\r\n}\r\n::ng-deep.modalConfigJSONagent .modal-dialog {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  top: 0%!important;\r\n  .modal-content{\r\n    width:88vw !important;\r\n  }\r\n}\r\n::ng-deep.modalConfigJSONagentbig .modal-dialog {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  top: 0%!important;\r\n  left:1% !important;\r\n  .modal-content{\r\n    width:85vw !important;\r\n  }\r\n}\r\n::ng-deep.modalConfigJSONagentsmall .modal-dialog {\r\n  margin: 0 !important;\r\n  padding: 0 !important;\r\n  top: 0%!important;\r\n  left:30% !important;\r\n  .modal-content{\r\n    width:30vw !important;\r\n    .messageioteditor{\r\n      .editor-container{\r\n        .monaco-editor{\r\n          width: 1139px !important;\r\n          height: 358px !important;\r\n          .overflow-guard{\r\n            width: 1139px !important;\r\n            height: 358px !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}","$btn-color: #17a0b4 !important;\r\n$fontsize: 12px !important;\r\n$btntextcolor: white !important;\r\n$btnHeight: 28px !important;\r\n$inputHeight:30px !important;\r\n$inputfontsize:11px !important;\r\n$primary:#004bff;\r\n// $modalHeaderTitleFont: ;\r\n@mixin modalheaderTtext {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
